<template>
  <v-container grid-list-lg pt-4 pa-0>
    <v-dialog
      v-model="isLoading"
      persistent
      fullscreen
      transition="fade-transition"
    >
      <v-layout
        justify-center
        align-center
        fill-height
        style="background-color:#1a19199c"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-dialog>

    <!-- </div> -->
    <v-form ref="form">
      <v-layout row wrap justify-center>
        <v-flex xs12 sm12 md5>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            color="blue"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormattedStart"
                readonly
                prepend-inner-icon="event"
                label="วันเริ่มต้น*"
                solo
                hide-details
                v-on="on"
                color="blue"
                :rules="nameRules"
                @blur="date = parseDate(dateFormattedStart)"
                required
                ref="startDate_ref"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="th"
              v-model="startDate"
              no-title
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm12 md5>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            color="blue"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormattedEnd"
                readonly
                prepend-inner-icon="event"
                label="วันสิ้นสุด*"
                solo
                hide-details
                v-on="on"
                color="blue"
                :rules="nameRules"
                @blur="date = parseDate(dateFormattedEnd)"
                required
                ref="endDate_ref"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="th"
              v-model="endDate"
              no-title
              @input="menu2 = false"
              :min="startDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex d-flex md1 align-center>
          <v-btn color="blue lighten-1" @click="clickButton()">
            <v-icon class="mr-1">search</v-icon>
            ค้นหา
          </v-btn>
        </v-flex>
        <v-flex d-flex md1 align-center>
          <v-btn color="orange lighten-1" @click="queryExcelNursery()">
            <v-icon class="mr-1">download</v-icon>
            Excel
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap mt-1 mb-2>
      <v-flex md6 xs12 sm12>
        <v-card flat color="secondary">
          <v-card-text>
            <span class="headline white--text">จำนวนการปลูก (ต้น)</span>
            <v-layout
              row
              wrap
              justify-space-between
              align-end
              style="margin-top:-10px"
            >
              <v-flex sm12 xs12 md12 class="pb-0">
                <span
                  class="display-3 lineheight white--text font-weight-bold"
                  >{{ totalPlant }}</span
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md6 xs12 sm12>
        <v-card flat color="secondary">
          <v-card-text>
            <span class="headline white--text">จำนวนผู้ลงทะเบียนปลูก (คน)</span>
            <v-layout
              row
              wrap
              justify-space-between
              align-end
              style="margin-top:-10px"
            >
              <v-flex sm12 xs12 md12 class="pb-0">
                <span class="display-3 lineheight white--text font-weight-bold"
                  >{{ numberOfPeopleByTotlePlant }}
                </span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <div class="" v-if="!isLoading && totalPlantByNursery.length !== 0">
      <v-layout row wrap>
        <v-flex lg7 md7 xs12 sm12 style="border-right: 1px solid #a9a9a9;">
          <v-layout>
            <v-flex d-flex lg8 md8 xs12 sm12 align-center>
              <h2>รายหน่วยงาน</h2>
            </v-flex>
            <v-flex lg4 md4 xs12 sm12 style="display:flex;">
              <v-switch v-model="isShowAll" color="blue" hide-details inset
                ><template v-slot:label>
                  <div style="margin-top: 14px;">แสดงทั้งหมด</div>
                </template>
              </v-switch>
              <v-switch v-model="isShowPeople" color="blue" hide-details inset
                ><template v-slot:label>
                  <div style="margin-top: 14px;">แสดงจำนวนคน</div>
                </template>
              </v-switch>
            </v-flex>
          </v-layout>
          <!-- <pre>{{ totalPlantByNursery }}</pre> -->
          <v-layout row wrap>
            <v-flex
              lg4
              md4
              xs12
              sm12
              v-for="(i, index) in totalPlantByNursery"
              :key="index"
            >
              <v-card class="pa-3" style="width:100%">
                <v-card-title
                  class="font-weight-bold pl-0 pa-1"
                  style="font-size:18px"
                >
                  {{ i.department_name }}
                </v-card-title>
                <v-divider></v-divider>
                <table style="width:100%">
                  <thead style="font-weight: 700;">
                    <tr>
                      <td>
                        หน่วยงาน
                      </td>
                      <td style="width:20%; text-align: end;">
                        จำนวนต้น
                      </td>
                      <td
                        style="width:20%; text-align: end;"
                        v-if="isShowPeople"
                      >
                        จำนวนคน
                      </td>
                    </tr>
                  </thead>
                  <!-- v-if="parseInt(j.userPlantSum) == 0 ? isShowAll : !isShowAll" -->
                  <!-- <div > -->
                  <tr v-for="(j, index2) in i.sub_department" :key="index2">
                    <td style="width:50%">
                      {{ j.department_name }}
                    </td>
                    <td style="width:25%; text-align: end;">
                      <!-- v-show="
                      parseInt(i.sub_department[index2].userPlantSum) != 0 ?
                      isShowAll : !isShowAll " -->
                      {{ commaSeparateNumber(parseInt(j.userPlantSum)) }}
                    </td>
                    <td style="width:25%; text-align: end;" v-if="isShowPeople">
                      {{ commaSeparateNumber(j.numberofpeople) }}
                    </td>
                  </tr>
                  <!-- </div>  -->
                </table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex lg3 md3 xs12 sm12 style="border-right: 1px solid #a9a9a9;">
          <v-layout row wrap>
            <v-flex d-flex lg8 md8 xs12 sm12 align-center
              ><h2>รายจังหวัด</h2>
            </v-flex>
            <v-flex d-flex lg4 md4 xs12 sm12 align-end>
              <v-btn depressed @click="sort()" text>
                <v-icon>sort</v-icon>
                เรียงลำดับ
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex d-flex lg12 md12 xs12 sm12>
              <table>
                <thead style="font-weight: 700;">
                  <tr>
                    <td>
                      จังหวัด
                    </td>
                    <td style="text-align: end;">
                      จำนวนต้น
                    </td>
                    <td style="text-align: end;">
                      จำนวนคน
                    </td>
                  </tr>
                </thead>
                <tr v-for="(k, index3) in filteredList" :key="index3">
                  <td>{{ k.name }}</td>
                  <td style="text-align: end;">
                    {{ commaSeparateNumber(k.userPlantSum) }}
                  </td>
                  <td style="text-align: end;">
                    {{ commaSeparateNumber(k.numberofpeople) }}
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex lg2 md2 xs12 sm12>
          <v-layout row wrap>
            <v-flex d-flex lg12 md12 xs12 sm12 align-center pt-3
              ><h2>ต้นไม้ Top 15</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex d-flex lg12 md12 xs12 sm12>
              <table>
                <thead style="font-weight: 700;">
                  <tr>
                    <td>ลำดับที่</td>
                    <td>ชนิดไม้</td>
                    <td style="text-align: end;">จำนวน (ต้น)</td>
                  </tr>
                </thead>
                <tr v-for="(l, index4) in listPlant" :key="index4">
                  <td>
                    {{ index4 + 1 }}
                  </td>
                  <td>
                    {{ l.plant_name }}
                  </td>
                  <td style="text-align: end;">
                    {{ commaSeparateNumber(l.sumPlant) }}
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex d-flex lg12 md12 xs12 sm12 align-center pt-3
              ><h2>สถิติหน่วยงานอื่น</h2>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex d-flex lg12 md12 xs12 sm12>
              <table>
                <thead style="font-weight: 700;">
                  <tr>
                    <td>
                      หน่วยงาน
                    </td>
                    <td style="text-align: end;">
                      จำนวนต้น
                    </td>
                    <td style="text-align: end;">
                      จำนวนคน
                    </td>
                  </tr>
                </thead>
                <tr v-for="(m, index5) in totalOtherDepartment" :key="index5">
                  <td>
                    {{ m.department_name }}
                  </td>
                  <td style="text-align: end;">
                    {{ commaSeparateNumber(m.userPlantSum) }}
                  </td>
                  <td style="text-align: end;">
                    {{ commaSeparateNumber(m.numberofpeople) }}
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- <v-layout row wrap> -->
      <!-- <v-flex md2 xs12 sm6 v-for="(i, index) in filteredList" :key="index">
        </v-flex> -->
      <!-- </v-layout> -->
      <!-- <v-layout row wrap v-if="filteredList.length === 0" justify-center mt-2>
        <v-flex xs1>
          <h2>ไม่พบข้อมูล</h2>
        </v-flex>
      </v-layout> -->
    </div>
  </v-container>
</template>

<script>
// var _ = require("lodash");
import moment from "moment";
export default {
  data() {
    return {
      dialog: true,
      dateFormattedStart: "",
      dateFormattedEnd: "",
      startDate: "",
      endDate: "",
      search: "",
      totalPlant: "",
      totalPlantByProvince: [],
      isSort: true,
      isLoading: false,
      numberOfPeopleByTotlePlant: "",
      userRegister: "",
      totalPlantByNursery: [],
      rowsPerPageItems: [24, 8, 12],
      pagination: {
        rowsPerPage: 24,
      },
      isShowPeople: true,
      isShowAll: true,
      nameRules: [(v) => !!v || "Name is required"],
      menu2: false,
      menu: false,
      listPlant: [],
      test: [],
      isFirstTime: true,
      totalOtherDepartment: [],
    };
  },
  created() {
    this.isLoading = true;
    this.startDate = "2024-01-01";
    this.endDate = moment().format("YYYY-MM-DD");
    // console.log(this.endDate);
    this.queryStatTotal();
    this.queryStatByProvince();
    this.queryReportNursery();
    this.queryPlantTopFifteen();
    this.queryOtherDepartment();
    this.$emit("activeMenu", "statistic");
  },
  watch: {
    startDate() {
      this.dateFormattedStart = this.formatDate(this.startDate);
    },
    endDate() {
      this.dateFormattedEnd = this.formatDate(this.endDate);
    },
    isShowAll() {
      if (this.isShowAll) {
        this.queryReportNursery();
      } else {
        var test = this.totalPlantByNursery;
        test.forEach((entry) => {
          entry.sub_department = entry.sub_department.filter(
            (number) => number.userPlantSum !== "0"
          );
        });
      }
    },
  },
  computed: {
    filteredList() {
      return this.totalPlantByProvince.filter((post) => {
        return post.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    clickButton() {
      // this.isLoading = true;
      this.queryStatTotal();
      this.queryStatByProvince();
      this.queryReportNursery();
      this.queryPlantTopFifteen();
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      var year_thai = parseInt(year) + 543;
      return `${day}/${month}/${year_thai}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      var year_2 = parseInt(year) - 543;
      return `${year_2}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    queryStatTotal() {
      this.axios
        .post(
          process.env.VUE_APP_IPFLASK +
            "/queryStatWithDate/totalUserPlantWithDate",
          {
            startDate: this.startDate,
            endDate: this.endDate,
          }
        )
        .then((response) => {
          // console.log(response.data);
          this.totalPlant = this.commaSeparateNumber(
            response.data.userPlantSum
          );
          this.numberOfPeopleByTotlePlant = this.commaSeparateNumber(
            response.data.numberofpeople
          );
          this.userRegister = this.commaSeparateNumber(
            response.data.userRegister
          );
        });
    },
    queryStatByProvince() {
      this.axios
        .post(
          process.env.VUE_APP_IPFLASK +
            "/queryStatWithDate/totalUserPlant/byProvinceWithDate",
          {
            startDate: this.startDate,
            endDate: this.endDate,
          }
        )
        .then((response) => {
          // console.log(response.data);
          this.totalPlantByProvince = response.data;
          this.isLoading = false;
        });
    },
    queryReportNursery() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryReportNursery", {
          startDate: this.startDate,
          endDate: this.endDate,
        })
        .then((response) => {
          // console.log(response.data);
          this.totalPlantByNursery = response.data;
          this.isLoading = false;
          this.isShowAll = true;
        });
    },
    queryOtherDepartment() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryOtherDepartment", {
          startDate: this.startDate,
          endDate: this.endDate,
        })
        .then((response) => {
          // console.log(response.data);
          this.totalOtherDepartment = response.data;
          this.isLoading = false;
          // this.isShowAll = true
        });
    },
    commaSeparateNumber(val) {
      while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    },
    sort() {
      if (this.isSort) {
        this.isSort = false;
        return this.totalPlantByProvince.sort(function(a, b) {
          return b.userPlantSum - a.userPlantSum;
        });
      } else {
        this.isSort = true;
        return this.totalPlantByProvince.sort(function(a, b) {
          return a.userPlantSum - b.userPlantSum;
        });
      }
    },
    queryPlantTopFifteen() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryPlantTopFifteen")
        .then((response) => {
          // console.log(response.data);
          this.listPlant = response.data;
          this.isLoading = false;
        });
    },
    queryExcelNursery() {
      console.log(this.$refs.startDate_ref.validate());
      this.isLoading = true;
      // if (!this.$refs.form.validate()) {
      //   if (
      //     !this.$refs.startDate_ref.validate() &&
      //     !this.$refs.startDate_ref.validate()
      //   ) {
      //     this.$swal("กรุณาเลือกวันที่ต้องการ Export ข้อมูล", "", "error");
      //     return;
      //   }
      //   if (!this.$refs.startDate_ref.validate()) {
      //     this.$swal("กรุณาเลือกวันเริ่มต้น", "", "error");
      //     return;
      //   }
      //   if (!this.$refs.endDate_ref.validate()) {
      //     this.$swal("กรุณาเลือกวันสิ้นสุด", "", "error");
      //     return;
      //   }
      // }
      console.log("queryExcelNursery");
      this.link =
        process.env.VUE_APP_IPFLASK +
        "/getFileNursery/report/" +
        this.startDate +
        "_" +
        this.endDate +
        "_" +
        moment().format("H:mm:ss") +
        ".xlsx";
      // console.log(this.link);
      window.location = this.link;
      this.isLoading = false;
      // this.link = process.env.VUE_APP_IPFLASK + "/getFile/report/" + this.startDate + "_" + this.endDate + ".xlsx";
    },
  },
};
</script>

<style scoped>
.lineheight {
  line-height: 1.2 !important;
}
.lineheight30 {
  line-height: 1.2 !important;
}

.v-list__tile__content {
  font-size: 16px !important;
  font-weight: 500;
}

.v-label .theme--light {
  height: 0px !important;
  line-height: 23px !important;
}
</style>
